import { create } from "zustand";
import { CardType } from "../types";

interface HookProps {
  open: boolean;
  todo: CardType | null;
  onOpenChange: (open: boolean) => void;
  setTodo: (td: CardType | null) => void;
}

export const useTodoViewModal = create<HookProps>()((set) => ({
  open: false,
  todo: null,
  onOpenChange: (open) =>
    set(() => ({
      open,
    })),
  setTodo: (td) =>
    set(() => ({
      todo: td,
    })),
}));
